import React from 'react';
import { useInView, motion } from 'framer-motion';
import * as S from './styles';

const testimonials = [
  {
    quote:
      'Economizo pelo menos 5 horas por semana. Antes eu tinha planilhas no Excel, grupos no WhatsApp e ainda anotava em papel. Agora tudo está no Excursei.',
    author: 'Mariana Ribeiro',
    role: 'Organizadora há 8 anos',
    initials: 'MR',
  },
  {
    quote:
      'As notificações automáticas de pagamento foram um divisor de águas. Não preciso mais ficar correndo atrás de ninguém — o app faz isso por mim.',
    author: 'Carlos Lima',
    role: 'Opera 15+ excursões por ano',
    initials: 'CL',
  },
  {
    quote:
      'O controle de documentos salvou minha pele em uma fiscalização. Abri o app e mostrei tudo na hora. Profissionalismo em outro nível!',
    author: 'Paula Souza',
    role: 'Guia turística certificada',
    initials: 'PS',
  },
];

export const TestimonialsSection: React.FC = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.12 });

  return (
    <S.Section ref={ref}>
      <S.Header>
        <motion.span
          initial={{ opacity: 0, y: 26 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <S.SectionTag>Depoimentos</S.SectionTag>
        </motion.span>
        <S.SectionTitle
          as={motion.h2}
          initial={{ opacity: 0, y: 26 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Quem usa, não quer largar
        </S.SectionTitle>
        <motion.p
          initial={{ opacity: 0, y: 26 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <S.SectionSub>Organizadores reais. Resultados reais.</S.SectionSub>
        </motion.p>
      </S.Header>
      <S.Grid>
        {testimonials.map((t, i) => (
          <motion.div
            key={t.author}
            initial={{ opacity: 0, y: 26 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.1 + i * 0.09 }}
          >
            <S.Card>
              <S.Stars>★★★★★</S.Stars>
              <S.Quote>{t.quote}</S.Quote>
              <S.Author>
                <S.AuthorAv>{t.initials}</S.AuthorAv>
                <S.AuthorInfo>
                  <strong>{t.author}</strong>
                  <span>{t.role}</span>
                </S.AuthorInfo>
              </S.Author>
            </S.Card>
          </motion.div>
        ))}
      </S.Grid>
    </S.Section>
  );
};
